/*
  GoGrowth — carry Swatch King group labels into the cart.

  Swatch King "groups" link separate products as fake options (e.g. Size:
  Crystal Small / Reindeer Small). They're not Shopify variants, so the cart
  drawer, checkout and order only showed the real variant ("Set of 2").
  Right before any add-to-cart form submits, this adds a hidden line-item
  property  properties[<group option name>] = <this product's value>,
  which Shopify shows in the cart, checkout and order.
*/
(function () {
  if (window.__ggGroupProps) return;
  window.__ggGroupProps = true;

  var index = null;

  function buildIndex() {
    var groups = window.starapps_data && window.starapps_data.product_groups;
    if (!groups || !groups.length) return null;
    var map = {};
    groups.forEach(function (g) {
      (g.option_values || []).forEach(function (v) {
        if (v.handle && g.option_name && v.option_value && !map[v.handle]) {
          map[v.handle] = { name: g.option_name, value: v.option_value };
        }
      });
    });
    return map;
  }

  function handleFromHref(href) {
    var m = href && href.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function formHandle(form) {
    if (form.dataset.ggHandle) return form.dataset.ggHandle;
    var card = form.closest(".grid-item, .grid-product");
    if (card) {
      var link = card.querySelector('a[href*="/products/"]');
      return link ? handleFromHref(link.getAttribute("href")) : null;
    }
    if (form.classList.contains("pdp-form")) return handleFromHref(location.pathname);
    return null;
  }

  function ensure(form) {
    if (!form || !/\/cart\/add/.test(form.getAttribute("action") || "")) return;
    index = index || buildIndex();
    if (!index) return;
    var info = index[formHandle(form)];
    if (!info) return;
    var name = "properties[" + info.name + "]";
    var input = form.querySelector('input[data-gg-group-prop]');
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.setAttribute("data-gg-group-prop", "");
      form.appendChild(input);
    }
    input.name = name;
    input.value = info.value;
  }

  // Collection cards: Swatch King swaps the card's title/link/image to the
  // clicked group product but leaves the card form's variant id on the
  // original product, so "Add to cart" added the wrong jar. Before a card
  // form posts, point its id at the product the card currently shows.
  function syncCardVariant(form) {
    var handle = formHandle(form);
    var idInput = form.querySelector('[name="id"]');
    if (!handle || !idInput) return Promise.resolve();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    return fetch(root + "products/" + encodeURIComponent(handle) + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) return;
        var current = String(idInput.value);
        var owns = p.variants.some(function (v) { return String(v.id) === current; });
        if (owns) return;
        var pick = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        idInput.value = pick.id;
      })
      .catch(function () {});
  }

  // Capture phase runs before the theme's own submit/click handlers.
  document.addEventListener("submit", function (e) {
    var form = e.target;
    ensure(form);
    if (!form.closest || !form.closest(".grid-item, .grid-product")) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    syncCardVariant(form).then(function () {
      ensure(form);
      HTMLFormElement.prototype.submit.call(form);
    });
  }, true);
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest('button, input[type="submit"]');
    if (btn) ensure(btn.form || btn.closest("form"));
  }, true);
})();
